// Copyright (c) 2017 Deere & Company'

import '../index.scss';
import React, {PropTypes} from 'react';
import CreateLayoutModalBody from './create-layout-modal-body';
import CreateLayoutModalFooter from './create-layout-modal-footer';
import CreateLayoutModalHeader from '../report-variant-modal-header';
import {WarrantyMediumModal} from '../../../../../shared/components/modal';

function handleCheckboxChange(selected) {

    this.actions.updateCreateLayoutModal('isSelected', selected);

}

function handleModalClose() {

    this.actions.resetCreateLayoutModal();

}

function handleInputChange(layoutName) {

    this.actions.updateCreateLayoutModal('layoutName', layoutName);

}

function handleSave() {

    const columnState = btoa(JSON.stringify(this.columnApi.getColumnState()));
    const filterModel = btoa(JSON.stringify(this.gridApi.getFilterModel()));
    const sortModel = btoa(JSON.stringify(this.gridApi.getSortModel()));

    this.actions.saveReportLayout({
        columnState,
        filterModel,
        isDefault: this.isSelected,
        name: this.layoutName,
        reportName: this.reportName,
        sortModel
    });

}

const CreateLayoutModal = props =>
    <WarrantyMediumModal
        className='create-layout-modal'
        isOpen={props.isOpen}
    >
        <CreateLayoutModalHeader
            headerText='SAVE_AS_NEW_LAYOUT'
            onCloseButtonClick={props::handleModalClose}
        />
        <CreateLayoutModalBody
            isSelected={props.isSelected}
            layoutName={props.layoutName}
            onCheckboxChange={props::handleCheckboxChange}
            onInputChange={props::handleInputChange}
        />
        <CreateLayoutModalFooter
            onCancel={props::handleModalClose}
            onSave={props::handleSave}
        />
    </WarrantyMediumModal>;

CreateLayoutModal.displayName = 'CreateLayoutModal';
CreateLayoutModal.propTypes = {
    actions: PropTypes.object.isRequired,
    columnApi: PropTypes.object.isRequired,
    gridApi: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    isSelected: PropTypes.bool.isRequired,
    layoutName: PropTypes.string.isRequired,
    reportName: PropTypes.string.isRequired
};

export default CreateLayoutModal;



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-variant-modals/create-layout-modal/create-layout-modal.js